import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";

export default class ButtonDecor extends Phaser.GameObjects.Container {
    constructor(scene, x, y, id) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.soundManager = scene.soundManager
        this.id = id

        this.isLocked = false
        this.isViewed = false

        this.addBody()        
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    setClickFunction( clickFunction ){
        this.on('pointerup', () => {
            this.soundManager.playOnce('Button2')
            this.scene.tweens.add({
                targets: this,
                scale: 0.7,
                duration: 100,
                yoyo: true,
                ease: 'Cubic.easeInOut',
                onComplete: () => {
                    clickFunction(this);
                }
            })
        }, this.scene);
    }

    addBody(){
        this.background = this.scene.add.circle(0, 0, 18, Colors.Elmt.Orange);
        this.background.setStrokeStyle(4, Colors.Elmt.White, 0.78);
        this.add(this.background);

        this.textElmt = this.scene.add.text(0, 0, "?", {
            fontFamily: FONTS.Inter28SemiBold,
            fontSize: '28px',
            color: Colors.Text.White,
        });
        this.textElmt.setOrigin(0.5);
        this.add(this.textElmt);

        this.setSize(this.background.width, this.background.height);
    }

    pointerOver(){
        this.background.setStrokeStyle(4, Colors.Elmt.White, 1);
    }

    pointerOut(){
        this.background.setStrokeStyle(4, Colors.Elmt.White, 0.78);
    }

    setViewed(){
        // Ajout de l'état vu
        this.isViewed = true
        this.background.setFillStyle(Colors.Elmt.Blue);
        this.textElmt.setText("!");
    }

    setLocked(){
        // Ajout de l'état bloqué
        this.isLocked = true
    }

    setUnlocked(){
        // Ajout de l'état débloqué
        this.isLocked = false
    }
}